module.exports = __webpack_public_path__ + "static/media/quad2.cafead28.png";